import { ButtonLink, Divider, H1 } from "@biketravel/solid-ui";
import { CircleIcon, RestoreConfirmForm } from "@biketravel/component";
import { useCurrentRoute, useNavigate } from "@biketravel/solid-router";
import { Title } from "@solidjs/meta";
import { FiArrowLeft, FiKey } from "solid-icons/fi";

export const RestoreConfirmPage = () => {
    const { navigate } = useNavigate();
    const currentRoute = useCurrentRoute<{
        token: string;
    }>();

    return (
        <>
            <Title>Изменение пароля</Title>
            <CircleIcon icon={<FiKey/>}/>
            <H1 modifiers='center'>Изменение пароля</H1>
            <RestoreConfirmForm
                token={currentRoute().params.token}
                onSuccess={() => navigate('home')}/>
            <Divider/>
            <ButtonLink to='auth_login' leftIcon={<FiArrowLeft/>} modifiers='block'>
                Вернуться к форме авторизации
            </ButtonLink>
        </>
    )
}